<template>
  <FormMainContainer
    :title="title"
    :breadcrumb="getBreadcrumb"
    :previous-step-route="previousStepRoute"
  >
    <KbCategories :lang="lang" :categories="services" />
  </FormMainContainer>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import FormMainContainer from '~concierge/components/FormMainContainer.vue'
import HeaderSection from '~concierge/components/HeaderSection.vue'
import FooterSection from '~concierge/components/FooterSection.vue'
import KbCategories from '~conciergeUiCommons/components/KnowledgeDatabase/KbCategories.vue'
import { BreadcrumbResource, KbServicesData, KbLocalization } from '~types/concierge'
import { useSubmissionFormStore } from '~conciergeUiCommons/store/submissionFormStore'
import { wTrans } from 'laravel-vue-i18n'

export default defineComponent({
  components: { HeaderSection, FooterSection, KbCategories, FormMainContainer },
  props: {
    services: {
      type: Array as PropType<KbServicesData[]>,
      required: true
    }
  },
  computed: {
    previousStepRoute(): string {
      if (this.services && this.services.length) {
        const service = this.services.find(e => typeof e !== 'undefined')

        return service?.endpoints.home ?? ''
      }

      return ''
    },
    title(): string {
      return wTrans('kb.title').value
    },
    getBreadcrumb(): { [key: number]: BreadcrumbResource } {
      if (this.services && this.services.length) {
        const service = this.services.find(e => typeof e !== 'undefined')

        if (Array.isArray(service?.breadcrumb)) {
          return service?.breadcrumb[this.lang as keyof KbLocalization] ?? []
        }
      }

      return []
    },
    lang(): string {
      return useSubmissionFormStore().formLanguage ?? 'fr'
    }
  }
})
</script>
